import { Card as SemanticCard } from 'semantic-ui-react';

export { CardProps, StrictCardProps } from 'semantic-ui-react';

export const Card: typeof SemanticCard = SemanticCard;

export default Card;
